import State from '../interfaces/states/State';

import Month from '../interfaces/Month';

import { createSelector } from 'reselect';
import getFilteredActivityMonthes from './getFilteredActivityMonthes';

const userExplorerMonths = createSelector(
  (state: State) => getFilteredActivityMonthes(state),
  (state: State) => state.activity.months,
  (filteredActivityArray: number[], months: Month[]): any[] => {
    if (filteredActivityArray) {

      const copyMonths = JSON.parse(JSON.stringify(months)); // copy array with objects

      return filteredActivityArray.map(month => {
        copyMonths[month].active = true;
        return copyMonths;
      });
    } else {
      return null;
    }
  }
);

export default userExplorerMonths;
